import { classes } from "@omnia/shared/react/react";
import { EditorUser, GenericProps } from "../../types";
import { Checkbox } from "@omnia/shared/react/checkbox";

interface Props extends GenericProps {
    members: EditorUser[]
}

export function UserLevelActivation({ state, dispatch, members }: Props) {

    const update = (userId: number, restrictCroppingAccess: boolean) => {
        dispatch({
            type: "updateUser",
            payload: {
                userId,
                restrictCroppingAccess
            }
        })
    }

    return <>

        <div className="any title" style={{ gridColumn: 1 }}>
            <span>
                Access any cropping
            </span>
        </div>

        {
            members.map((user, index) => {

                return <div
                    key={user.userId}
                    className={classes("any user", (index === (members.length - 1) && "last"))}
                    style={{ gridColumn: (index + 2) }}>

                    <Checkbox
                        checked={!user.restrictCroppingAccess}
                        setChecked={c => update(user.userId, !c)}
                    />

                </div>
            })

        }
    </>

}

